import * as React from "react";
import styled from "styled-components";
import {format, parseISO} from "date-fns";
import SessionList from "./SessionList";

const DateCard = ({ date, sessions }) => {
    const cardRef = React.useRef(null);
    return (
        <ColorWrapper ref={cardRef} style={{ backgroundColor: '#9333ea' }}>
            <CardContent>
                <CardTitle>{format(parseISO(date), 'MMM dd, EEE')}</CardTitle>
                {sessions.map((session) => (
                    <SessionList key={session.id} session={session} />
                ))}
            </CardContent>
        </ColorWrapper>
    );
}

const ColorWrapper = styled.article`
    border-radius: 5px;
    width: 100%;
    padding: 0 0 0 6px;
    box-shadow: 0 0 0 1px rgba(206, 212, 218, 1);
    position: relative;
`;

const CardContent = styled.div`
    border-radius: 5px;
    background-color: #fff;
    display: flex;
    width: 100%;
    flex-direction: column;
    padding-top: 11px;
    box-shadow: 0 0 0 1px rgba(206, 212, 218, 1);
    position: relative;
`;

const CardTitle = styled.h2`
    color: #000;
    font-family: 'Inter', sans-serif;
    font-weight: 500;
    font-size: 21px;
    text-align: left;
    margin: -1px 0 10px 8px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
`;

export default DateCard;